module.exports = __webpack_public_path__ + "static/metal05-237180fcb35920899b3dbae8fd5936f3.png";